import React from "react";
import { useTranslation } from "react-i18next";
import InstructionPageShell from "./InstructionPageShell";

export default function InstructionRecommendations() {
  const { t } = useTranslation("instructions");

  return (
    <InstructionPageShell
      blockTitle={t("recommendations.blockTitle")}
      pageTitle={t("recommendations.pageTitle")}
      body={t("recommendations.body")}
    />
  );
}
